<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <TeamClientsTable
          ref="clientsTable"
          :account-id="$route.params.accountId"
          :team-id="$route.params.teamId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import TeamClientsTable from '@/components/Application/Manage/Account/TeamsClientsTable'

export default {
  components: {
    TeamClientsTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'API Clients',
        route: { name: 'manage-accounts-account-configurations-teams-team-clients', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } }
      }
    }
  },
  mounted () {
    this.actions = this.$refs.clientsTable.actions
  }
}
</script>
